import { css, jsx } from '@emotion/react';
import { labelStyles } from '@zapier/style-encapsulation';

const isNumber = (value) => typeof value === "number";
const Styles = labelStyles("Grid", {
  root: (props) => css({
    display: "grid",
    alignItems: props.alignItems,
    gap: props.gap,
    gridTemplateColumns: isNumber(props.columns) ? `repeat(${props.columns}, 1fr)` : props.columns
  })
});
const Grid = (props) => {
  return jsx("div", { css: Styles.root(props), "data-zds": true }, props.children);
};

export { Grid };
//# sourceMappingURL=Grid.es.js.map
